import Link from 'next/link';

import { TSidebarLink } from '../model/type';

type TSidebarProps = {
  sidebarItems: TSidebarLink[];
  addtionalInfo: React.ReactNode;
  currentPath: string;
};

export const Sidebar = ({ sidebarItems, addtionalInfo, currentPath }: TSidebarProps) => {
  return (
    <div className='bg-hover rounded-md sticky right-0 top-0 hidden md:flex flex-col justify-between overflow-y-auto min-h-[calc(100svh_-_265px)] p-3 min-w-[250px]'>
      <div className='flex items-center justify-center flex-col gap-1'>{addtionalInfo}</div>
      <span className='border-b border-border w-full block'></span>
      <div className='flex flex-1 flex-col gap-2 pt-5 pb-[10.24px]'>
        {sidebarItems?.map((item) => {
          const isActive = currentPath === item.route || currentPath.startsWith(`${item.route}/`);

          return (
            <Link
              key={item.route}
              href={item.route}
              onClick={item.clickHandler}
              className={`${
                isActive ? 'bg-blue-1 text-white' : 'text-text hover:bg-background hover:text-text'
              } flex items-center justify-start gap-4 py-4 px-2 rounded-lg`}
            >
              {item.icon}
              <p
                //data-testid={`sidebar-${item.id}`}
                className='body-12-bold leading-[150%] whitespace-nowrap'
              >
                {item.label}
              </p>
            </Link>
          );
        })}
      </div>
    </div>
  );
};
